import React from "react";
import Navigate from "../../../components/Navigate";
import SuccessImg from '../../../assets/img/success-img.svg';

export const SuccessFP = () => {
    return (
        <div className='mx-auto mobile-full-width shadow bg-white p-5 rounded login-width'>
            <div align='center'>
                <p className='lead fw-bold'>Congratulations!</p>
                <small>All done, your password has been reset successfully.</small>
                <div className="mt-4 w-75 mx-auto mobile-full-width">
                    <img src={SuccessImg} alt='success onboard' className='img-fluid mb-5'/>
                    <Navigate path='/onboard/login'>
                        <button className="btn btn-primary mb-4 w-50 mobile-full-width">Back to Login</button>
                    </Navigate>
                </div>
            </div>
        </div>
    )
}